
import { useEffect, useState } from "react";
import { getBookingHistoryAPI, getMultipleBookingHistoryAPI } from "../../services/Networkcall";
import { errorAlert } from "../../components/common/Alert";
import { Loader } from "../../components/common/Loader";
import GateCodesTableMultiple from "../../pages/gateCode/GateCodeStableMultiple";
import GateCodesTable from "../../pages/gateCode/GateCodesTable";
import { Card } from "react-bootstrap";

export default function BookingHistory() {

    const [singleBookings, setSingleBookings] = useState(null);
    const [multipleBookings, setMultipleBookings] = useState(null);
    const [loading, setLoading] = useState(false);
    const [singleBookingPagination, setSingleBookingPagination] = useState({ page: 1, totalPages: 1, limit: 5, totalRecords: 1 })
    const [multipleBookingPagination, setMultipleBookingPagination] = useState({ page: 1, totalPages: 1, limit: 5, totalRecords: 1 })
    const [bookingMode, setBookingMode] = useState("multiple");
    const [refetch, setRefetch] = useState(false);



    // ==================FETCH ALL BOOKINGS=================
    const fetchBookingHistory = async () => {
        setLoading(true);
        const payload = {
            page: singleBookingPagination?.page,
            limit: singleBookingPagination?.limit,
        }
        try {
            const res = await getBookingHistoryAPI(payload);
            if (res?.success) {
                setSingleBookings(res?.data || [])
                setSingleBookingPagination((pre) => ({ ...pre, totalPages: res?.totalNumberOfPages, totalRecords: res?.totalRecords }))
            } else {
                errorAlert({ message: res?.message });
            }
        } catch (err) {
            errorAlert({ message: err?.response?.data?.message || err?.message || "something went wrong" })
        } finally {
            setLoading(false);
        }
    }

    const fetchMultipleBookingHistory = async () => {
        setLoading(true);
        const payload = {
            page: multipleBookingPagination?.page,
            limit: multipleBookingPagination?.limit,
        }
        try {
            const res = await getMultipleBookingHistoryAPI(payload);
            if (res?.success) {
                setMultipleBookings(res?.data || [])
                setMultipleBookingPagination((pre) => ({ ...pre, totalPages: res?.totalNumberOfPages, totalRecords: res?.totalRecords }))
            } else {
                errorAlert({ message: res?.message });
            }
        } catch (err) {
            errorAlert({ message: err?.response?.data?.message || err?.message || "something went wrong" })
        } finally {
            setLoading(false);
        }
    }

    // ==================HANDLLE PAGINATION=================
    const singleBookingPageHandler = (page) => {
        setSingleBookingPagination((pre) => ({ ...pre, page: page }));
    }

    const multipleBookingPageHandler = (page) => {
        setMultipleBookingPagination((pre) => ({ ...pre, page: page }));
    }


    // ==================Effect=================
    useEffect(() => {
        if (bookingMode === "single") {
            fetchBookingHistory();
        } else {
            fetchMultipleBookingHistory();
        }
    }, [bookingMode, singleBookingPagination.page, multipleBookingPagination.page])

    useEffect(() => {
        if (refetch) {
            fetchMultipleBookingHistory();
            setRefetch(false);
        }
    }, [refetch]);

    return (
        <Card className="gc-table">
            <Loader show={loading} />

            {/* TABLE */}
            {/* <div className="px-3 ">
                <div className="booking-tabs">
                    <div
                        className={`tab ${bookingMode === "single" ? "active" : ""}`}
                        onClick={() => setBookingMode("single")}
                    >
                        Single Booking
                    </div>

                    <div
                        className={`tab ${bookingMode === "multiple" ? "active" : ""}`}
                        onClick={() => setBookingMode("multiple")}
                    >
                        Multiple Booking
                    </div>
                </div>
            </div> */}

            {bookingMode === "single" ? (
                <GateCodesTable
                    border={false}
                    bookings={singleBookings}
                    pagination={singleBookingPagination}
                    pageHandler={singleBookingPageHandler}
                />
            ) : (
                <GateCodesTableMultiple
                    border={false}
                    setRefetch={setRefetch}
                    bookings={multipleBookings}
                    pagination={multipleBookingPagination}
                    pageHandler={multipleBookingPageHandler}
                />
            )}
        </Card>
    );
}